



















import LoadingIndicator from '@/components/LoadingIndicator'
import VueOptions from '@utils/VueOptions'
import OfferListAlertBar from './OfferListAlertBar'
import OfferResourceList from '@/modules/host/ui/ResourceList/OfferResourceList'
import AcceptAllOffersTriggerModal from '@/modules/ui/triggers/Offers/AcceptAllOffersTriggerModal.vue'
import DenyAllOffersTriggerModal from '@/modules/ui/triggers/Offers/DenyAllOffersTriggerModal.vue'
import SetOfferShippingAreaTriggerModal from '@triggers/Offer/SetOfferShippingAreaTriggerModal'

settings = 
  name: 'OfferList'

  resources: 
    offers: 
      resourceName: 'offer'
      slug: 'offers'
      infinityScroll: true
      fetch: false

  vue: 
    components: {
      LoadingIndicator,
      OfferListAlertBar,
      OfferResourceList,
      AcceptAllOffersTriggerModal,
      DenyAllOffersTriggerModal,
      SetOfferShippingAreaTriggerModal,
    }

    data: ->
      bulkActionResultItems: []

    mounted: ->
      @refetchMember()

    computed:
      offerListOptions: -> { resourceComponent : this, hideRowSize: true }
      offerTitlePrefix: ->
        return 'All' unless @$route.query.scope?
        return @$route.query.scope

    methods: 
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      promptToAcceptAll: ->
        @$refs.acceptAllOffersTriggerModal.fire()
      onOffersAcceptAll: ->
        @$refs.offerResourceList.setFilters()
        @$refs.acceptAllOffersTriggerModal.close()

      promptToDenyAll: ->
        @$refs.denyAllOffersTriggerModal.fire()
      onOffersDenyAll: ->
        @$refs.offerResourceList.setFilters()
        @$refs.denyAllOffersTriggerModal.close()

      promptToSetShippingArea: (offer) ->
        payloadOptions = {}
        modalOptions = { offer }
        @$refs.setOfferShippingAreaTrigger.fire payloadOptions, modalOptions
      onOfferSetShippingArea: ->
        # @$refs.setOfferShippingAreaTrigger.close()

export default VueOptions.vue settings
